import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../services/api";
import Swal from "sweetalert2";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "../styles/auth.css";

export default function Register() {
  const navigate = useNavigate();

  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  const submit = async (e) => {
    e.preventDefault();

  //     if (e.target.password.value !== e.target.confirmPassword.value) {
  //       return Swal.fire("Error", "Passwords do not match", "error");
  //     }

  //     try {
  //       await axios.post("/auth/register", {
  //         fullname: e.target.fullname.value,
  //         mobile: e.target.mobile.value,
  //         email: e.target.email.value,
  //         password: e.target.password.value
  //       });

  //       // Swal.fire("Success", "Admin Registered", "success");
  //       Swal.fire({
  //         icon: "success",
  //         title: "Admin Registered",
  //         timer: 1100,
  //         // showConfirmButton: false,
  //       });


  //       setTimeout(() => navigate("/login"), 1000);
  //     }catch (err) {
  //       const msg =
  //         err.response?.data?.message ||
  //         "Server not responding. Please try again.";

  //       Swal.fire({
  //         icon: "error",
  //         title: "Registration Failed",
  //         text: msg,
  //         confirmButtonText: "OK"
  //       });
  // }

    Swal.fire({
        icon: "error",
        title: "Registration full",
        text: "you can't registered",
        confirmButtonText: "OK"
      });
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h3 className="auth-title">Admin Register</h3>

        <form onSubmit={submit}>
          <div className="form-group">
            <input className="form-control" name="fullname" placeholder="Full Name" required />
          </div>

          <div className="form-group">
            <input className="form-control" name="mobile" placeholder="Mobile Number" required />
          </div>

          <div className="form-group">
            <input className="form-control" name="email" placeholder="Email Address" required />
          </div>

          <div className="form-group password-wrapper">
            <input
              className="form-control"
              name="password"
              type={showPass ? "text" : "password"}
              placeholder="Password"
              required
            />
            <span className="eye-btn" onClick={() => setShowPass(!showPass)}>
              {showPass ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </span>
          </div>

          <div className="form-group password-wrapper">
            <input
              className="form-control"
              name="confirmPassword"
              type={showConfirmPass ? "text" : "password"}
              placeholder="Confirm Password"
              required
            />
            <span className="eye-btn" onClick={() => setShowConfirmPass(!showConfirmPass)}>
              {showConfirmPass ? <VisibilityOffIcon /> : <VisibilityIcon />}
            </span>
          </div>

          <button className="btn auth-btn">REGISTER</button>
        </form>

        <button className="switch-btn" onClick={() => navigate("/login")}>
          <h2>Already Admin? Login </h2>
        </button>
      </div>
    </div>
  );
}
